export enum SearchItemCompanyDtoProps {
  CompanyKey = 'companyKey',
  Ticker = 'ticker',
  CompanyName = 'companyName',
  CompanyTicker = 'companyTicker',
}
